export default {
  // / <summary>
  // / Quyền xem
  // / </summary>
  View: 1,
  // / <summary>
  // / Quyền thêm
  // / </summary>
  Add: 2,
  // / <summary>
  // / Quyền sửa
  // / </summary>
  Edit: 4,
  // / <summary>
  // / Quyền xóa
  // / </summary>
  Delete: 8,
  // Chuyển loại khoản
  ConvertBudgetKindItem: 9,
  // Chuyển TK
  ConvertAccount: 10,
  // Chuyển nguồn
  ConvertBudgetSource: 11,
  // Thiết lập quyền hạn
  SettingRole: 12,
  // / <summary>
  // / Quyền ghi sổ
  // / </summary>
  Posted: 16,
  // / <summary>
  // / Quyền bỏ ghi
  // / </summary>
  UnPost: 32,
  CopyData: 38, // Sao chép dữ liệu
  PayAdvancePayment: 50, // Thanh toán bảng kê
  RecordReceiptExpense: 51, // Ghi thu - ghi chi
  CancelReceiptExpense: 52, // Hủy Ghi thu - ghi chi
  RecordReceiptNSNN: 53, // Ghi thu vào NSNN
  CancelReceiptNSNN: 54, // Hủy ghi thu vào NSNN
  // / <summary>
  // / Quyền in
  // / </summary>
  Print: 64,
  // / <summary>
  // / Phát hành hóa đơn
  // / </summary>
  ReleaseEInvoice: 128,
  // / <summary>
  // / Gửi hóa đơn
  // / </summary>
  SendInvoice: 256,
  // / <summary>
  // / Chuyển thành chứng từ giấy
  // / </summary>
  ConvertIntoPaperVoucher: 512,
  // / <summary>
  // / Tải hóa đơn
  // / </summary>
  DownloadInvoice: 1024,
  // / <summary>
  // / Hủy hóa đơn
  // / </summary>
  CancelInvoice: 2048,

  // / <summary>
  // / Sao lưu dữ liệu
  // / </summary>
  BackupData: 4096,

  // / <summary>
  // / Phục hồi dữ liệu
  // / </summary>
  RestoreData: 8192,

  // / <summary>
  // / Thêm mới dữ liệu
  // / </summary>
  CreateData: 16384,

  // / <summary>
  // / Thêm mới dữ liệu năm trước
  // / </summary>
  CreateDataPrevYear: 32768,

  // / <summary>
  // / Xóa dữ liệu
  // / </summary>
  DeleteData: 65536,

  // / <summary>
  // / Đổi tên dữ liệu
  // / </summary>
  RenameData: 131072,

  // / <summary>
  // / Phục hồi chứng từ
  // / </summary>
  RestoreVoucher: 262144,
  // / <summary>
  // / bảo trì
  // / </summary>
  RebuildData: 210801,

  //Nhập khẩu danh mục
  ImportDic: 111,
  Attach: 23, // đính kèm (DVC)
  DeleteFileAttach: 24, // xóa tệp đính kèm (DVC)
  SendFileChiefAcc: 25, // gửi hồ sơ lên kế toán trưởng (DVC)
  ChiefAccAccept: 26, // kế toán trưởng ký duyệt (DVC)
  ChiefAccReject: 27, // kế toán trưởng từ chối (DVC)
};
